import { Link } from "react-router-dom";

const TocPrivacyPolicyFooter = () => {
  return (
    <footer className="toc-privacypolicy-footer">
      <p className="copy-right">© Pointment 2024</p>
      <nav className="nav">
        <Link className="nav-item" to="/toc">
          Terms and Conditions
        </Link>
        <span className="nav-item-divider" />
        <Link className="nav-item" to="/privacypolicy">
          Privacy Policy
        </Link>
      </nav>
    </footer>
  );
};

export default TocPrivacyPolicyFooter;
